export default __webpack_public_path__ + "static/media/cealect_logo.c242611a.png";